<!--
/**
* @name: ContextMenu.vue
* @description: 弹窗菜单
* @author: 温永江
* @create: 2020/07/22 15:56:31
* @update: 2020/07/22 15:56:31
*/
-->

<template>
  <div :class="css.ctx" :style="{ left: l, top: t }" v-if="show" v-clickoutside="hide">
    <div :class="css.item" v-for="(item, i) in list" :key="item" @click="onClick(item, i)" @contextmenu.prevent>{{ item }}</div>
  </div>
</template>
<script>
export default {
  props: {
    top: String,
    left: String,
    show: Boolean,
  },
  data() {
    return {
      visible: this.show,
    };
  },
  model: {
    prop: 'show',
    event: 'showChange',
  },
  computed: {
    t() {
      return `${parseInt(this.top) + 15}px`;
    },
    l() {
      return `${parseInt(this.left)}px`;
    },
    list() {
      return ['关闭', '关闭其他', '关闭所有'];
    },
  },
  watch: {
    show(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit('showChange', v);
    },
  },
  methods: {
    hide() {
      this.visible = false;
    },
    onClick(item, i) {
      this.$emit('close', i);
      this.hide();
    },
  },
};
</script>
<style lang="postcss" module="css">
.ctx {
  position: fixed;
  top: -99999px;
  left: 0;
  background-color: white;
  border-radius: var(--radius);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--color-border);
  z-index: 999;
  & .item {
    padding: 5px 12px;
    cursor: pointer;
    white-space: nowrap;
    &:hover {
      background-color: #eee;
    }
  }
}
</style>
